<template>
  <div>
    <carousel-slide />
    <carousel-slide-footer />
    <company-vision />
    <company-stats />
    <what-we-do />
    <!-- <project-summary /> -->
    <happy-clients />
  </div>
</template>

<script>
import CarouselSlide from "./CarouselSlide";
import CarouselSlideFooter from "./CorouselSlideFooter";
import CompanyVision from "./CompanyVision";
import CompanyStats from "./CompanyStats";
import WhatWeDo from "./WhatWeDo";
// import ProjectSummary from "./ProjectSummary";
import HappyClients from "./HappyClients";

export default {
  name: "HomeView",
  components: {
    CarouselSlide,
    CarouselSlideFooter,
    CompanyVision,
    CompanyStats,
    WhatWeDo,
    // ProjectSummary,
    HappyClients
  },
  metaInfo: {
    title: "Home",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Johnson styles construction is construction company that provides a wide variety of  renovation services, building services, landscaping services and many more. "
      }
    ]
  }
};
</script>
